<div id="<%= dom_id song %>" class="w-full sm:w-auto my-5 space-y-5">
  <div>
    <strong class="block font-medium mb-1">Dance:</strong>
    <%= song.dance_id %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Title:</strong>
    <%= song.title %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Artist:</strong>
    <%= song.artist %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Order:</strong>
    <%= song.order %>
  </div>
</div>
